import React from 'react';

type IconProps = {
  className?: string;
  title?: string;
};

export const WindIcon: React.FC<IconProps> = ({ className, title }) => (
  <svg
    aria-hidden={!title}
    role={title ? 'img' : 'presentation'}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    {title ? <title>{title}</title> : null}
    <path d="M3 8h12a3 3 0 100-6 3 3 0 010 6H3" />
    <path d="M3 14h9a2 2 0 100-4 2 2 0 010 4H3" />
    <path d="M3 20h6a1 1 0 100-2 1 1 0 010 2H3" />
  </svg>
);

export const LineChartIcon: React.FC<IconProps> = ({ className, title }) => (
  <svg
    aria-hidden={!title}
    role={title ? 'img' : 'presentation'}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    {title ? <title>{title}</title> : null}
    <polyline points="3 17 9 11 13 15 21 7" />
    <path d="M21 21H3" />
  </svg>
);

export const GlobeIcon: React.FC<IconProps> = ({ className, title }) => (
  <svg
    aria-hidden={!title}
    role={title ? 'img' : 'presentation'}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    {title ? <title>{title}</title> : null}
    <circle cx="12" cy="12" r="9" />
    <path d="M2.05 12h19.9" />
    <path d="M12 2.05C13.7 5.5 13.7 18.5 12 21.95" />
    <path d="M12 2.05C10.3 5.5 10.3 18.5 12 21.95" />
  </svg>
);

export const SettingsIcon: React.FC<IconProps> = ({ className, title }) => (
  <svg
    aria-hidden={!title}
    role={title ? 'img' : 'presentation'}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    {title ? <title>{title}</title> : null}
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09a1.65 1.65 0 00-1-1.51 1.65 1.65 0 00-1.82.33l-.06.06A2 2 0 013.28 17.7l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09a1.65 1.65 0 001.51-1 1.65 1.65 0 00-.33-1.82L4.21 3.28A2 2 0 016.04.45l.06.06a1.65 1.65 0 001.82.33H8.1A1.65 1.65 0 009.1 1.1V1a2 2 0 014 0v.09c.25.08.49.2.7.36" />
  </svg>
);

export const SparklesIcon: React.FC<IconProps> = ({ className, title }) => (
  <svg
    aria-hidden={!title}
    role={title ? 'img' : 'presentation'}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    {title ? <title>{title}</title> : null}
    <path d="M12 2l1.5 3L17 7l-3.5 1L12 11l-1.5-3L7 7l3.5-2L12 2z" />
    <path d="M20 14l1 2l2 1l-2 1l-1 2l-1-2l-2-1l2-1l1-2z" />
  </svg>
);

export const BellIcon: React.FC<IconProps> = ({ className, title }) => (
  <svg
    aria-hidden={!title}
    role={title ? 'img' : 'presentation'}
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    {title ? <title>{title}</title> : null}
    <path d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6 6 0 10-12 0v3.159c0 .538-.214 1.055-.595 1.436L4 17h5" />
    <path d="M13.73 21a2 2 0 01-3.46 0" />
  </svg>
);
